import { render, staticRenderFns } from "./UserTransactionsTable.vue?vue&type=template&id=42841558&scoped=true&"
import script from "./UserTransactionsTable.vue?vue&type=script&lang=js&"
export * from "./UserTransactionsTable.vue?vue&type=script&lang=js&"
import style0 from "./UserTransactionsTable.vue?vue&type=style&index=0&id=42841558&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42841558",
  null
  
)

export default component.exports